<template>
<div>
    <div>

        <ul class="cart-item">
            <li class="buy-item">
                <div class="goods-pic"><img :src="CartList.goods_image_url"/></div>
                <div class="goods-info">
                    <dl>
                        <dt class="goods-name"><a>{{CartList.goods_name}}</a></dt>
                        <dd class="goods-type"></dd>
                        <dd class="goods-subtotal">
                            <span class="goods-price">{{CartList.goods_price}}</span><span v-if="CartList.goods_price<CartList.goods_original_price" class="ml-5 goods-original-price">{{CartList.goods_original_price}}</span>
                            <span class="goods-count">×{{CartList.quantity}}</span>
                        </dd>
                    </dl>
                </div>
            </li>
        </ul>
        <div class="cart-subtotal">
            <div class="message">
                <mt-field label="备注" placeholder="店铺订单留言:" type="textarea" v-model="message" @change="changeMessage()"></mt-field>
            </div>
            <div v-if="CartList.voucher_list.length" @click="voucherVisible=true"><mt-cell class="menu-item" title="代金券" ><span slot="icon" class="left-icon iconfont">&#xe6f2;</span>{{myVoucher}}<i class="indicator iconfont">&#xe650;</i></mt-cell></div>
            <checkout-desc class="desc-item mt-5" title="商品金额" v-if="CartList.goods_discount_total>0" :subtitle="CartList.goods_original_total"></checkout-desc>
            <checkout-desc class="desc-item" title="优惠" v-if="CartList.goods_discount_total>0" :subtitle="CartList.goods_discount_total" :discount="true"></checkout-desc>
            <checkout-desc class="desc-item" title="本店合计" :subtitle="totalAmount"></checkout-desc>
        </div>
      <mt-popup v-model="voucherVisible" position="right" class="common-popup-wrapper">
            <div class="common-header-wrap">
                <mt-header title="代金券" class="common-header">
                    <mt-button slot="left" icon="back" @click="voucherVisible=false"></mt-button>
                    <mt-button slot="right" @click="selectVoucher('')">不使用</mt-button>
                </mt-header>
            </div>
            <div class="common-popup-content">
                <div class="common-voucher common-voucher02" :class="(item.voucher_state != 1)?'disable':''" v-for="(item,index) in CartList.voucher_list" :key="item.voucher_id" @click="selectVoucher(item)">
                    <div class="par"><p>订单满{{item.voucher_limit}}元</p><sub class="sign">￥</sub><span>{{item.voucher_price}}</span></div>
                    <div class="copy">有效期至<p><br>{{$moment.unix(item.voucher_enddate).format('YYYY.MM.DD')}}</p></div>
                    <i></i>
                </div>
            </div>
        </mt-popup>
    </div>
</div>
</template>

<script>
import CheckoutDesc from './CheckoutDesc'
export default {
  name: 'CheckoutStore',
  data () {
    return {
      totalAmount: '',
      voucherVisible: false,
      message:  '',
      myVoucher: '',
      voucherVisible: false,
    }
  },
  components: {
    CheckoutDesc
  },
  props: ['CartList'],
  created: function () {
    this.calcOrder()
  },
  methods: {
    changeMessage () {
      this.$emit('changeMessage', this.message)
    },
    selectVoucher (voucherInfo) {
      this.voucherVisible=false
      this.$emit('selectVoucher', voucherInfo)
      this.CartList.voucher_info = voucherInfo
      this.calcOrder()
    },
    calcOrder () {
      let price = parseFloat(this.CartList.goods_total)
      if (this.CartList.voucher_list.length) {
        if(this.CartList.voucher_info){
          price -= parseFloat(this.CartList.voucher_info.voucher_price)

          this.myVoucher=this.CartList.voucher_info.voucher_price + '元'
        }else{
          this.myVoucher='不使用'
        }
      }
      if (price < 0) {
        price = 0
      }
      this.totalAmount = price
    },
  }
}
</script>

<style scoped>

    .cart-item{background-color: #FFF;
        border-bottom: solid 0.05rem #EEE;}
    .buy-item{    display: block;
        position: relative;
        z-index: 1;
        margin:0 0.5rem;
        padding: 0.5rem 0;}
    .buy-item .goods-pic{display: block;
        width: 2.7rem;
        height: 2.7rem;
        padding: 0.2rem;
        position: absolute;
        z-index: 1;
        top: 0.5rem;
        left: 0rem;
        border: solid 0.05rem #EEE;
        border-radius: 0.2rem;}
.buy-item .goods-pic img{width: 2.7rem;
    height: 2.7rem;}
.buy-item .goods-info{    display: block;
        vertical-align: top;
        height: 3.1rem;
        margin-left:4rem;
        position: relative;
        z-index: 1;}
.buy-item .goods-info .goods-name a {
    display: block;
    height: 1rem;
    font-size: 0.7rem;
    color: #666666;
    line-height: 1rem;
    overflow: hidden;
}
.buy-item .goods-info  .goods-type {
    overflow: hidden;
    white-space: nowrap;
    width: 70%;
    height: 0.9rem;
    font-size: 0.45rem;
    line-height: 0.9rem;
    color: #999;
    text-overflow: ellipsis;
}
    .buy-item .goods-info .goods-original-price{text-decoration: line-through;font-size:.65rem;color:#999}
.buy-item .goods-info  .goods-subtotal {
    display: block;
    height: 1rem;
    margin: 0 0.4rem 0 0rem;
    line-height: 1rem;
    font-size: 0.7rem;
    position: relative;
    z-index: 1;
}
.buy-item .goods-info  .goods-subtotal .goods-price {
    color: #DB4453;
    font-size: 0.7rem;
    font-weight: 600;
}
.buy-item .goods-info  .goods-subtotal  .goods-count {
    font-size: 0.7rem;
    line-height: 1rem;
    position: absolute;
    z-index: 1;
    top: 0rem;
    right: 1rem;
}
 .cart-subtotal{}
.cart-subtotal dl {
    position: relative;
    z-index: 1;
    height: 1rem;
    padding: 0.4rem 0 0;
    font-size: 0;
}
.cart-subtotal dt {
    position: absolute;
    z-index: 1;
    top: 0.4rem;
    left: 0.4rem;
    display: block;
    width: 50%;
    height: 1rem;
    font-size: 0.6rem;
    line-height: 1rem;
}
.cart-subtotal dd {
    height: 1rem;
    margin: 0 0.5rem 0 50%;
    text-align: right;
    font-size: 0.6rem;
    line-height: 1rem;
}
.cart-subtotal .message {
    position: relative;
    z-index: 1;
    display: block;
    padding-top: 0.4rem;
}
.desc-item {
    height: 1.5rem;
}
.common-voucher{margin:0.5rem auto}
    .left-icon{float:left;font-size:0.9rem;margin-right:0.2rem;}
</style>
